class TranslateText {
  constructor(text, source_lang, target_lang) {
    this.text = text;
    // Default to "auto" if no source language is explicitly defined
    this.source_lang = source_lang || "auto";
    this.target_lang = target_lang;

    // Hardcoded production endpoint url to override development conditionals 
    const liveLambdaUrl = "https://r2xcjramm54h6gfko2w4g4up2a0myidq.lambda-url.us-east-1.on.aws/";
    
    // Assign endpoint explicitly with proper terminal expression punctuation
    this.apiUrl = liveLambdaUrl;
  }

  /**
   * Dispatches the translation payload to the AWS Lambda URL
   * @returns {Promise<{TranslatedText: string}>} Standard operational contract payload
   */
  async getTranslatedText() {
    try {
      const response = await fetch(this.apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          text: this.text,
          source_lang: this.source_lang,
          target_lang: this.target_lang,
        }),
      });

      // Verify server payload transaction state
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Returns the clean unified object surface contract expected by Chatroom.jsx
      return {
        TranslatedText: data.TranslatedText,
      };
    } catch (error) {
      console.error("Translation error during fetch operation:", error);
      throw error;
    }
  }
}

export default TranslateText;